/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConsentAnswerDto } from '../models/ConsentAnswerDto';
import type { ConsentTextDto } from '../models/ConsentTextDto';
import type { CreateConsentDto } from '../models/CreateConsentDto';
import type { UpdateConsentDto } from '../models/UpdateConsentDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ConsentService {

    /**
     * @param sessionId
     * @returns ConsentTextDto Success
     * @throws ApiError
     */
    public static consentGetConsents(
        sessionId?: string,
    ): CancelablePromise<ConsentTextDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/GetConsentsAsync',
            query: {
                'sessionId': sessionId,
            },
        });
    }

    /**
     * @param sessionId
     * @returns ConsentAnswerDto Success
     * @throws ApiError
     */
    public static consentGetConsentAnswer(
        sessionId?: string,
    ): CancelablePromise<Array<ConsentAnswerDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/GetConsentAnswerAsync',
            query: {
                'sessionId': sessionId,
            },
        });
    }

    /**
     * @param sessionId
     * @param requestBody
     * @returns string Success
     * @throws ApiError
     */
    public static consentPostConsentAnswer(
        sessionId?: string,
        requestBody?: CreateConsentDto,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/PostConsentAnswerAsync',
            query: {
                'sessionId': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param uuid
     * @param requestBody
     * @returns string Success
     * @throws ApiError
     */
    public static consentUpdateConsentAnswer(
        uuid?: string,
        requestBody?: UpdateConsentDto,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/UpdateConsentAnswerAsync',
            query: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
